import { notify } from '~/helpers/Toast';
import api from '~/services';
import i18n from '~/translate/i18n';

const languages = {
  'pt-BR': 'message',
  'en-US': 'message_en',
};

function getFilters(filters) {
  const params = {
    campaign_type: 'ces',
    campaign: filters.campaign,
    start_date: filters.dates.start,
    end_date: filters.dates.end,
  };

  Object.keys(params).forEach((obj) => {
    if (!params[obj]) {
      delete params[obj];
    }
  });

  return params;
}

const getDashboard = async (filters) =>
  api
    .get('/overview', {
      params: getFilters(filters),
    })
    .then((res) => res.data)
    .catch((err) => {
      notify('error', err.response.data.errors[0][languages[i18n.language]]);
    });

export { getDashboard };
